import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { env } from '../../../services/AppService';

export default function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 21, width: 100, mr: 2 }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 274 314"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
	  <image
	  href={`${env.DOMAIN}/kat-red-girl.png`}
	  width="274"
	  height="314"
	  />
      </svg>
    </SvgIcon>
  );
}
